import axios from 'axios';

import { storage } from 'src/utils/storage';

// API base URL'ini ayarla
// Development'ta Vite proxy kullanıyoruz, bu yüzden baseURL boş olmalı
// Production'da nginx proxy kullanıyoruz, yine baseURL boş olmalı (aynı origin)
const API_URL = import.meta.env.MODE === 'production' ? "" : "";

// Axios instance oluştur
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  withCredentials: true, // Enable cookies for session management
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Axios interceptor - JWT token'ı otomatik header'a ekle
axiosInstance.interceptors.request.use(
  config => {
    const token = storage.get('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor - sadece 401 (oturum süresi dolmuş) durumunda otomatik logout.
// 403 (FORBIDDEN) "yetkisin yok bu işlem için" anlamına gelir, oturumu kapatmaz — bileşen
// kendi hatasını gösterir (manager rolü ile admin-only endpoint'e basıldığında olduğu gibi).
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      storage.remove('token');

      const currentPath = window.location.pathname;
      if (currentPath !== '/sign-in') {
        storage.set('redirectAfterLogin', currentPath);
      }

      window.location.href = '/sign-in';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance; 